import { useApplicantsHead } from '~/domains/applicants/queries/applicantHead'
import { parseIdList } from '~/utils/lists'
import { formatName } from '~/utils/names'
import { chipValueMore } from '../FilterBar.css'

export const ApplicantsChipValue = ({ value }: { value: string }) => {
  const heads = useApplicantsHead({ applicantIds: parseIdList(value) })
  const applicants = heads.flatMap(({ data }) => (data ? [data] : []))
  const first = applicants[0]
  if (!first) {
    return null
  }
  return (
    <>
      {formatName(first)}{' '}
      {applicants.length > 1 && (
        <span className={chipValueMore}>+{applicants.length - 1}</span>
      )}
    </>
  )
}
